import React from "react";
import { SEO, PageLayout, HeroElement } from "@bluefin/components";
import { Grid, List } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getPageHeroImage } from "../utils/utils";

export default class PizzaThreeOaksPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getPageHeroImage({
            options: fishermanBusinessWebsitePage.components,
          })}
        />
        <PageLayout
          hero={
            <HeroElement
              header={"Pizza in Three Oaks"}
              tagline={""}
              images={getPageHeroImage({
                options: fishermanBusinessWebsitePage.components,
              })}
              ctas={[
                fishermanBusiness.ctas.address,
                fishermanBusiness.ctas.phone,
              ]}
              ctaInverted={true}
              ctaColor={"white"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={true}
              fullWidth={true}
              parallax={false}
              containerAs={"none"}
              height={500}
            />
          }
          className={"pizza-three-oaks-page"}
        >
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column computer={12} mobile={16}>
              <h1>
                Pizza in Three Oaks at The Featherbone Restaurant & Lounge
              </h1>
              <div>
                Yes — The Featherbone Restaurant & Lounge serves pizza in Three
                Oaks, MI, for lunch and dinner.
              </div>
              <div>
                Pull up for a specialty pie, build-your-own toppings, or
                cauliflower crust, then stick around for burgers, salads, and a
                laid-back night out.
              </div>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column computer={12} mobile={16}>
              <h2>Our Pizza Lineup</h2>
              <div>
                We’re a restaurant first — and pizza is a big part of the meal.
                At The Featherbone you’ll find classic cheese pies,
                always-available cauliflower crust, and specialty pizzas built
                for sharing (or not sharing — we don’t judge).
              </div>
              <div>Specialty pies on the menu:</div>
              <List
                items={[
                  "BBQ Chicken &amp; Red Onion",
                  "Supreme — pepperoni, sausage, onion, green peppers, black olives",
                  "Chicken Bacon Ranch",
                  "Meat Lovers — pepperoni, sausage, chicken, and bacon",
                  "Garlic Veggie — tomatoes, broccoli, garlic &amp; olive oil",
                  "Cheese (12&quot; &amp; 16&quot;)",
                  "Cauliflower Crust (12&quot;) — always available",
                ]}
              />
              <div>
                Looking for cauliflower crust pizza in Three Oaks? We’ve got you
                — the 12" cauliflower crust is always on the board, ready for
                cheese, toppings, or a specialty build.
              </div>
              <div>
                <strong className={"bolded"}>
                  See current pies and pricing on the menu PDF:
                </strong>
                <a href={"https://thefeatherbone.com/menu/"}>
                  View the full menu
                </a>
              </div>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column computer={12} mobile={16}>
              <h2>Build Your Own</h2>
              <div>
                Want it your way? Start with a 12" or 16" cheese pizza and add
                toppings like pepperoni, sausage, bacon, green peppers, black
                olives, green olives, onions, mushrooms, diced tomatoes,
                pineapple, jalapeños, or extra cheese.
              </div>
              <div>
                Feeling saucy? Specialty sauces — ranch, BBQ, and creamy garlic
                — are on the menu too.
              </div>
              <div>
                <span className={""}>
                  Full topping and sauce details live on the food menu:
                </span>
                <a href={"https://thefeatherbone.com/menu/"}>
                  thefeatherbone.com/menu
                </a>
              </div>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column computer={12} mobile={16}>
              <h2>More Than Pizza</h2>
              <div>
                Featherbone is a full restaurant — not a pizza-only counter.
                Pair a pie with burgers, handhelds, salads, wings, entrees, and
                whatever else sounds good that night.
              </div>
              <div>
                <span className={""}>Browse everything here:&nbsp;</span>
                <a href={"https://thefeatherbone.com/menu/"}>Menu</a>
                <span className={""}>&nbsp;· or head back to the &nbsp;</span>
                <a href={"https://thefeatherbone.com/"}>Home</a>
                <span className={""}>
                  &nbsp;page for the vibe and hours at a glance.
                </span>
              </div>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column computer={12} mobile={16}>
              <h2>Hours, Location & How To Order</h2>
              <List
                items={[
                  "Kitchen: 11:30 AM – 10:30 PM",
                  "Lounge / bar: 11:30 AM – 2:00 AM",
                ]}
              />
              <div>
                Pizza and food are available through kitchen hours — last pizza
                through 10:30 PM. The bar stays open later; food stops when the
                kitchen does.
              </div>
              <List
                items={[
                  "Find us: 6741 US Hwy 12, Three Oaks, MI 49128",
                  "Call: (269) 756-6821",
                  "Order Online: use the Order Online button on thefeatherbone.com",
                  "Contact: Contact page",
                ]}
              />
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column computer={12} mobile={16}>
              <h2>A Laid-Back Three Oaks Spot</h2>
              <div>
                We proudly serve the greater Three Oaks community — friendly
                service, good food, and a small-town vibe that works for a
                weeknight dinner or a weekend stop with friends. Come hungry,
                stay as long as you like (kitchen through 10:30 PM; lounge
                later).
              </div>
              <div>
                Family and kid friendly. Large groups welcome. We take
                reservations — just give us a call at (269) 756-6821.
              </div>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Row>
              <Grid.Column computer={12} mobile={16}>
                <h2>FAQ</h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column computer={12} mobile={16}>
                <Grid stackable={true} className={""} textAlign={"center"}>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>Do you serve pizza in Three Oaks?</h4>
                      <p>
                        Yes. The Featherbone Restaurant & Lounge serves pizza
                        for lunch and dinner at 6741 US Hwy 12 in Three Oaks,
                        MI. You’ll find cheese pies, cauliflower crust (always
                        available), and specialty pizzas alongside the rest of
                        our full restaurant menu. Call (269) 756-6821 or order
                        online from our site when you’re ready.
                      </p>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>What specialty pizzas does The Featherbone have?</h4>
                      <p>
                        Our specialty pies include BBQ Chicken & Red Onion,
                        Supreme, Chicken Bacon Ranch, Meat Lovers, and Garlic
                        Veggie, plus cheese and a cauliflower-crust option.
                        Toppings and specialty sauces are listed on the current
                        food menu. Check https://thefeatherbone.com/menu/ for
                        the latest lineup and pricing.
                      </p>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>What sizes and crust options do you offer?</h4>
                      <p>
                        We offer 12" and 16" pizzas, including a 12" cauliflower
                        crust that’s always available. You can stick with
                        cheese, add toppings, or go with a specialty pie. Full
                        details are on our food menu PDF linked from the Menu
                        page.
                      </p>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>What are your kitchen and bar hours?</h4>
                      <p>
                        The kitchen is open from 11:30 AM to 10:30 PM, and the
                        lounge bar runs from 11:30 AM to 2:00 AM. Those hours
                        are posted on our homepage at
                        https://thefeatherbone.com. If you’re coming for pizza,
                        plan to order while the kitchen is open — food stops
                        with the kitchen.
                      </p>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>Do you offer cauliflower-crust pizza?</h4>
                      <p>
                        Yes — we have a 12" cauliflower crust option on the
                        pizza menu, and it’s always available. Specialty
                        toppings and sauces can be added the same way as our
                        other pies. See the current menu at
                        https://thefeatherbone.com/menu/ for details.
                      </p>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>Where are you located and how do I order?</h4>
                      <p>
                        Find us at 6741 US Hwy 12, Three Oaks, MI 49128. Call
                        (269) 756-6821, use Order Online on
                        https://thefeatherbone.com, or visit for dine-in. Full
                        menu details are at https://thefeatherbone.com/menu/.
                      </p>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>Are you family or group friendly?</h4>
                      <p>
                        Yes — we’re family and kid friendly, and we welcome
                        large groups. We’re a laid-back restaurant and lounge
                        serving the greater Three Oaks community, with pizza,
                        burgers, and a full menu for lunch or dinner. We take
                        reservations — call (269) 756-6821. Check kitchen hours
                        (through 10:30 PM) before you come so everyone can eat
                        together.
                      </p>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className={"question-row"}>
                      <h4>How late can I order pizza?</h4>
                      <p>
                        Order pizza while the kitchen is open — through 10:30
                        PM. The lounge stays open later (until 2:00 AM), but
                        food wraps with kitchen hours. Calling ahead at (269)
                        756-6821 is a smart move near closing.
                      </p>
                      <p>
                        Hungry for pizza in Three Oaks? Check the menu, order
                        online, or call (269) 756-6821. See you at 6741 US Hwy
                        12.
                      </p>
                    </div>
                  </Grid.Column>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      ctas {
        address {
          text
          link
          internal
        }
        phone {
          text
          link
          internal
        }
      }
    }
    fishermanBusinessWebsitePage(title: { eq: "Pizza in Three Oaks" }) {
      title
      description
      components {
        fastId
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
